export default {
  current: {},
  all: [],
  internalFields: [
    { name: "title", type: "string" },
    { name: "_title", type: "string" },
    { name: "current_state", type: "string" },
    { name: "created_at", type: "date" },
    { name: "updated_at", type: "date" },
    { name: "last_exported_at", type: "date" },
    { name: "last_exported_via_bucket_id", type: "number" },
    { name: "sentiment_score", type: "number" },
    { name: "sentiment_magnitude", type: "number" },
    { name: "no_unread_conversations", type: "number" },
    { name: "unresolved_task_failures", type: "number" },
    { name: "case_document_id", type: "string" },
    { name: "id", type: "number" }
  ]
}
